


class EducoreStandardReport {
    constructor($scope, $state, $stateParams, $sce, $rootScope,
        authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS) {
        'ngInject';
        let self = this
        $rootScope.title = "Standard Report"
        $scope.loading = true
        $scope.filterObj = {}
        self.noAcademics = true
        let myUserId = localStorageService.get('user_id')
        let activeAcd = localStorageService.get('academic_year')
        let school_id = localStorageService.get('school_id')
        let thisSchoolId = school_id
        let filterThru = localStorageService.get('can_filter')
        var insideCourseware = false
        let LEVEL_ARRAY = [{
            level: "1",
            alias: "Easy"
        }, {
            level: "2",
            alias: "Medium"
        }, {
            level: "3",
            alias: "Difficult"
        }]
        //Boolean - To set view for fetch
        $scope.isFilter = true;

        //Object - Holds selection data
        $scope.selectAcademics = {};

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Standard Report"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            getSession()
        }


        function getSession() {
            self.noData = true
            $scope.toSearchObj = {
                user_id: myUserId,
                school_id: school_id,
                academic_year: activeAcd,
                exam: {
                    $exists: 1
                }
            }
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.sessions = response.result.data.details;
                        $scope.selectAcademics.session = undefined;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.curriculums = [];
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                        $scope.loading = false;
                    } catch (ex) {
                        console.log(ex)
                    }
                } else {
                    $scope.loading = false
                    toastr.error('Network Error. Please try later')
                }
                _.defer(function () {
                    $scope.$apply();
                });
            })
        }

        $scope.getCuriculum = (session) => {
            self.noData = true
            $scope.selectAcademics.session = session;
            $scope.toSearchObj.session = $scope.selectAcademics.session._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.curriculums = response.result.data.details;
                        $scope.selectAcademics.curriculum = undefined;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.classes = [];
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getClass = (curriculum) => {

            self.noData = true
            $scope.selectAcademics.curriculum = curriculum;
            $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classes = response.result.data.details;
                        $scope.selectAcademics.class = undefined;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.batches = [];
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getBatch = (xclass) => {

            self.noData = true
            $scope.selectAcademics.class = xclass;
            $scope.toSearchObj.class = $scope.selectAcademics.class._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.batches = response.result.data.details;
                        $scope.selectAcademics.batch = undefined;
                        $scope.selectAcademics.subject = undefined;
                        $scope.subjects = [];
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        $scope.getSubject = (batch) => {

            self.noData = true
            $scope.selectAcademics.batch = batch;
            $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
            authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.subjects = response.result.data.details;
                        $scope.selectAcademics.subject = undefined;
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
        $scope.fetchReport = function (subject) {

            self.noData = true
            $scope.selectAcademics.subject = subject;
            $scope.selectedAcademics = angular.copy($scope.selectAcademics);
            $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
            loadData($scope.toSearchObj)
        }

        $scope.uCanTrust = function (obj) {
            // string = "<span style='color: #89a000'>123</span>"
            if (obj && obj.color) {
                let color = obj.color['background-color']
                let string = '<span class="td-color" style="background-color:' + color + ';">' + obj.score + '</span>';
                return $sce.trustAsHtml(string);
            }

        }
        let authoring = localStorageService.get('authoringData')
        // loadData(authoring)
        function loadData(academics) {
            $scope.loading = true
            self.noAcademics = false
            self.academicsForExp = academics
            let send = {
                "conditions": {
                    "class_id": academics.class,
                    "curriculum_id": academics.curriculum,
                    "batch_id": academics.batch,
                    "subject_id": academics.subject,
                    "session_id": academics.session,
                    "school_id": school_id
                },
                "myUserId": myUserId,
                "acdYear": activeAcd,
                // "student_id": "q72pkhd4GGKeoy7sA",
                "pdfFlag": false,
                "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL,
                "SITE_URL": CONSTANTS.SITE_URL
            }
            authService.callAPI("/v0/educore_reports/standardEducore", "POST",
                { args: send }, function (resp) {
                    try {
                        if (!resp.error) {
                            let result = resp.result.data.details
                            console.log(resp)
                            if (result.types.length) {
                                self.hasResult = true
                            } else {
                                self.hasResult = false
                            }
                            self.themeArray = result.themeDocs

                            self.typeArray = result.types
                            self.tagArr = result.tags
                            self.levelArray = LEVEL_ARRAY
                            self.data_set = result.themeObj
                            self.tag_all_theme = result.tag_all_theme
                            self.level_all_theme = result.level_all_theme
                            self.type_all_theme = result.type_all_theme
                            self.batchObjArray = result.batchObjArray
                            self.batchArray = result.batchArray
                            self.scorePerBatch = result.scorePerBatch
                            self.allThemeTotalAllBatch = result.allThemeTotalAllBatch
                            self.header = result.header
                            self.bestSection = result.bestSection
                            self.lowestTheme = result.lowestTheme
                            self.bestTheme = result.bestTheme
                            self.total_score_per_batch = result.total_score_per_batch
                            self.levelAveragesPerTheme = result.levelAveragesPerTheme
                            self.tagAveragesPerTheme = result.tagAveragesPerTheme
                            self.typeAveragesPerTheme = result.typeAveragesPerTheme
                            self.totalTypeObj = result.totalTypeObj
                            self.totalLevelObj = result.totalLevelObj
                            self.totalTagObj = result.totalTagObj
                            self.generated_date = result.generated_date
                            self.generated_by = result.generated_by
                            let colSpanCountTag = 4 //setting collspan length in tag overalll
                            colSpanCountTag = colSpanCountTag + self.themeArray.length
                            self.tagCollSpan = colSpanCountTag
                            $scope.urls = result.pdf_url
                        } else {
                            console.log(resp.error)
                        }
                        $scope.loading = false
                        $scope.$apply()

                    } catch (e) {
                        $scope.loading = false
                        $scope.$apply()
                        console.log(e)
                    }
                })
        }



        self.export = () => {
            // $scope.loading = true
            $scope.isPdfData = true
            console.log($scope.urls)
            $scope.url = $sce.trustAsResourceUrl($scope.urls)
        }
        self.backToHtml = () => {
            $scope.isPdfData = false
        }
    }
}
export default EducoreStandardReport;


// WEBPACK FOOTER //
// ./src/app/educore_reports/standard/controllers/controller.js